import { c as _c } from "react/compiler-runtime";
import styles from './Buttton.module.scss';
export const Buttton = t0 => {
  const $ = _c(7);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  const t1 = `${styles.button} ${rest.className}`;
  let t2;
  if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
    t2 = <button type="button" {...rest} className={t1}>{children}</button>;
    $[3] = children;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};